// frontend/src/components/WorkshopDashboard/RequestQueue.js
// Replaces the "Incoming Requests" section wrapping <ViewRequests />.
// Sorted worst-first (pending, oldest), each row carrying its own next action.
// No scrollIntoView — the StatBar links here by state, not by scrolling.

import { IconWarn } from '../icons/Icons';

export default function RequestQueue({
  health, onAction, onOpenRequest, onOpenAll, busyId, error, limit = 6,
}) {
  const rows = health.queue.slice(0, limit);

  if (rows.length === 0) {
    return (
      <section className="flex-1 min-w-0 basis-[480px] rounded-2xl border border-[#241F1B] bg-gradient-to-b from-[#17140F] to-[#131110] p-6">
        <p className="text-[13px] text-[#74A98D]">Aucune demande ouverte. La file est vide.</p>
      </section>
    );
  }

  return (
    <section className="flex-1 min-w-0 basis-[480px] rounded-2xl border border-[#3A2622] bg-gradient-to-b from-[#1A1210] to-[#141110] overflow-hidden">
      <header className="flex flex-wrap items-center gap-2.5 px-[18px] py-[15px] border-b border-[#2B2724]">
        <span className="w-[26px] h-[26px] rounded-lg bg-[rgba(226,87,75,.14)] text-[#E2574B] flex items-center justify-center shrink-0">
          <IconWarn className="w-[15px] h-[15px]" />
        </span>
        <div className="flex-1 min-w-0 basis-[190px]">
          <h2 className="font-['Space_Grotesk',sans-serif] text-[14.5px] font-semibold tracking-[-.01em] text-[#F4F1EA]">
            File d’attente
          </h2>
          <p className="text-[11.5px] text-[#8F877B] mt-0.5">{health.queueSub}</p>
        </div>
        <button onClick={onOpenAll}
          className="h-[29px] px-3 rounded-lg border border-[#3A2622] bg-[rgba(226,87,75,.10)] hover:bg-[rgba(226,87,75,.18)]
                     text-[11.5px] font-semibold text-[#E88378] hover:text-[#F4F1EA] whitespace-nowrap transition-colors">
          Traiter la file
        </button>
      </header>

      {error && (
        <p className="px-[18px] py-2.5 border-b border-[#3A2622] bg-[rgba(226,87,75,.08)] text-[11.5px] text-[#E88378]">
          {error}
        </p>
      )}

      <ul>
        {rows.map(q => (
          <li key={q.id}
              className="flex items-center gap-3 px-[18px] py-3 border-b border-[#1E1B18] last:border-0 hover:bg-[#1A1613] transition-colors">
            <span className="w-[3px] self-stretch rounded-sm shrink-0" style={{ background: q.color }} />

            <button onClick={() => onOpenRequest?.(q.raw)} className="min-w-0 flex-1 basis-[150px] text-left">
              <div className="flex items-center gap-2">
                <span className="font-['Space_Grotesk',sans-serif] text-[12.5px] font-semibold tracking-[.02em] whitespace-nowrap text-[#F4F1EA]">
                  {q.plate}
                </span>
                <span className="text-[9px] font-semibold uppercase tracking-[.08em] px-1.5 py-0.5 rounded-[5px] whitespace-nowrap"
                      style={{ color: q.color, background: q.tint }}>
                  {q.status}
                </span>
              </div>
              <p className="text-[11px] text-[#7C7468] mt-[3px] truncate">{q.client} · {q.service}</p>
            </button>

            <div className="text-right shrink-0">
              <p className="text-[11px] tabular-nums whitespace-nowrap" style={{ color: q.ageColor }}>{q.age}</p>
              <p className="text-[10.5px] text-[#5C554C] mt-[3px] whitespace-nowrap">{q.channel}</p>
            </div>

            {q.action && (
              <button onClick={() => onAction?.(q.raw)} disabled={busyId === q.id}
                className="h-7 px-2.5 rounded-[7px] border border-[#2B2724] hover:border-[#4E4740] bg-[#1B1815] hover:bg-[#241F1B]
                           text-[11.5px] font-semibold text-[#C9C3B6] hover:text-[#F4F1EA] shrink-0 whitespace-nowrap transition-colors
                           disabled:opacity-50 disabled:cursor-wait">
                {busyId === q.id ? '…' : q.action}
              </button>
            )}
          </li>
        ))}
      </ul>

      {health.queue.length > limit && (
        <button onClick={onOpenAll}
          className="w-full py-3 text-[12px] text-[#8F877B] hover:text-[#F4F1EA] border-t border-[#1E1B18] transition-colors">
          Voir les {health.queue.length} demandes →
        </button>
      )}
    </section>
  );
}
